export default __webpack_public_path__ + "static/media/13.5b5476d5.jpg";